module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/10-c16a6e1c49798ca1237fa9a70ac132c2.png";